import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from "@mui/material";
import {
  API_get_activities,
  API_edit_activities,
  API_clone_activities,
  API_delete_activities,
} from "./utils/http";
import Addinginput from "./components/AddingInput";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import CopyAllRoundedIcon from "@mui/icons-material/CopyAllRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {
  COLUMN_ITINERRARY,
  COLUMN_ITINERRARY_DETAIL,
} from "./utils/constDispatch";
import { AlertCus } from "./components/AlertCus";
import AppBarSearchBox from "./components/SearchBox";
import { DialogCus } from "./components/DialogCus";
import { checkOper_or_admin, idToTimeYYYYMMD } from "./utils/tool";

export default function Itinerary({}) {
  const [search_text, set_search_text] = useState("");
  const [row_click, set_row_click] = useState(null);

  const [activities, set_activities] = useState(null);
  const [data_filter, set_data_filter] = useState(null);

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [density, setDensity] = React.useState("compact");

  const [new_code, set_new_code] = useState("");
  const [edit_ok, set_edit_ok] = useState(null);
  const [clone_ok, set_clone_ok] = useState(null);
  const [accom, set_accom] = useState(null);

  const [show_detail, set_show_detail] = useState(false);

  async function get_data_activities() {
    API_get_activities((data) => {
      if (data.success) {
        let data_act = data.data;
        let x_new = [];

        data_act.map((item) => {
          item.created_at = idToTimeYYYYMMD(item._id);
          x_new.push(item);
        });

        set_activities(x_new);
        set_data_filter(x_new);
        set_accom(data.accom);
      }
    });
  }

  async function edit_data_activities(id, data) {
    API_edit_activities(id, data, (data) => {
      set_edit_ok(data.success);
      get_data_activities();
    });
  }

  const handleClickOpen = () => {
    setOpen(!open);
  };
  const handleClickOpen1 = () => {
    setOpen1(!open1);
  };
  const handleClickOpen2 = () => {
    setOpen2(!open2);
  };

  useEffect(() => {
    get_data_activities();
  }, []);

  const handle_search = (search_text) => {
    if (search_text == "") {
      set_data_filter(activities);
    } else {
      let data_tmp = activities.filter((x) => {
        let str = x.label + x.accomodation_code + x.created_at;
        str = str.replace(/\W/g, "").toLocaleLowerCase();
        let str_search = search_text.replace(/\W/g, "").toLocaleLowerCase();
        return str.includes(str_search);
      });

      set_data_filter(data_tmp);
    }
  };

  const [selected_id, set_selected_id] = useState(null);
  const [rowSelection, setRowSelection] = useState([]);

  const confirm_delete = () => {
    handleClickOpen1();
    API_delete_activities(selected_id, (x) => {
      if (x.success) {
        get_data_activities();
      }
    });
  };
  const confirmClone = () => {
    handleClickOpen2();
    API_clone_activities(selected_id, new_code, (e) => {
      set_clone_ok(e.success);
      if (e.success) {
        get_data_activities();
      }
    });
  };

  if (activities != null && data_filter != null) {
    return (
      <Box style={{ flexDirection: "column", display: "flex" }}>
        <AppBarSearchBox
          title="Itinerary"
          value={search_text}
          onChange={(e) => {
            if (e.target.value == "") {
              handle_search("");
              set_selected_id(null);
            }
            set_search_text(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handle_search(search_text);
              set_selected_id(null);
            }
          }}
        />

        <AlertCus condition={edit_ok} message="Edit" />
        <AlertCus condition={clone_ok} message="Clone" />

        {checkOper_or_admin() ? (
          <Box
            sx={{
              display: "flex",
              padding: "12px 20px",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Button
              size="small"
              disabled={selected_id == null}
              variant="contained"
              disableElevation
              endIcon={<CopyAllRoundedIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => handleClickOpen2()}
            >
              Clone
            </Button>
            <Button
              size="small"
              disabled={selected_id == null}
              variant="outlined"
              color="error"
              endIcon={<DeleteRoundedIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => handleClickOpen1()}
            >
              Delete
            </Button>
          </Box>
        ) : null}

        <Dialog
          open={open}
          onClose={handleClickOpen}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "12px",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              fontSize: 17,
              borderBottom: "1px solid #E0E0E0",
              backgroundColor: "#F5F7FA",
              py: 1.5,
              px: 3,
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            Edit Itinerary
          </DialogTitle>
          <Box sx={{ p: 2, overflowY: "auto" }}>
            <Addinginput
              onHideClick={(id) => {
                edit_data_activities(id, { hide: true });
                handleClickOpen();
              }}
              onShowClick={(id) => {
                edit_data_activities(id, { hide: false });
                handleClickOpen();
              }}
              accom={accom}
              init_data={row_click}
              onSaveClick={(id, data) => {
                edit_data_activities(id, data);
                handleClickOpen();
              }}
            />
          </Box>
        </Dialog>
        <DialogCus
          open={open1}
          title="Confirm delete"
          handleClickOpen={handleClickOpen1}
          handleClickConfirm={confirm_delete}
        ></DialogCus>

        <DialogCus
          open={open2}
          title="Clone"
          handleClickOpen={handleClickOpen2}
          handleClickConfirm={confirmClone}
        >
          <DialogContent>
            <TextField
              placeholder="Enter new code"
              autoFocus
              value={new_code}
              onChange={(e) => set_new_code(e.target.value)}
              margin="dense"
              id="code"
              label="code"
              fullWidth
              variant="standard"
            />
          </DialogContent>
        </DialogCus>

        <Box
          sx={{
            height: "100%",
            width: "100%",
            padding: "0 20px 20px 20px",
            boxSizing: "border-box",
          }}
        >
          <Button
            size="small"
            variant="outlined"
            sx={{
              marginBottom: 1.5,
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: 13,
            }}
            onClick={() => set_show_detail(!show_detail)}
          >
            {show_detail ? "Hide detail" : "Show detail"}
          </Button>
          <Box
            sx={{
              "& .MuiDataGrid-root": {
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                overflow: "hidden",
                fontSize: 13,
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#F5F7FA",
                fontSize: 13,
                fontWeight: 600,
                color: "#555",
                borderBottom: "1px solid #E0E0E0",
              },
              "& .MuiDataGrid-row": {
                "&:hover": {
                  backgroundColor: "#F8FBFF",
                },
                "&.Mui-selected": {
                  backgroundColor: "#EBF4FF",
                  "&:hover": {
                    backgroundColor: "#DDEEFF",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #F0F0F0",
                py: 1,
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "1px solid #E0E0E0",
                backgroundColor: "#FAFAFA",
              },
            }}
          >
            <DataGrid
              slots={{ toolbar: GridToolbar }}
              getRowId={(item) => item._id}
              rows={data_filter}
              columns={
                show_detail ? COLUMN_ITINERRARY_DETAIL : COLUMN_ITINERRARY
              }
              initialState={{
                pagination: { paginationModel: { pageSize: 20 } },
              }}
              density={density}
              onDensityChange={(newDensity) => {
                setDensity(newDensity);
              }}
              pageSizeOptions={[5, 10, 20]}
              rowSelectionModel={rowSelection}
              onRowSelectionModelChange={(e) => {
                setRowSelection(e);
                set_selected_id(e[0]);
                set_row_click(activities.find((x) => x._id === e[0]));
              }}
              disableMultipleRowSelection={true}
              onCellDoubleClick={() => handleClickOpen()}
            />
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  }
}
